import { NavLink } from 'react-router-dom';
import './Layout.css';

const NAV_ITEMS = [
  { path: '/',                  label: 'Home',     slug: 'home' },
  { path: '/day-in-the-life',   label: 'Day',      slug: 'day' },
  { path: '/courses',           label: 'Courses',  slug: 'courses' },
  { path: '/schedule-builder',  label: 'Schedule', slug: 'schedule' },
  { path: '/clubs',             label: 'Clubs',    slug: 'clubs' },
  { path: '/sports-pe',         label: 'Sports',   slug: 'sports' },
  { path: '/events',            label: 'Events',   slug: 'events' },
  { path: '/rules',             label: 'Rules',    slug: 'rules' },
  { path: '/timeline',          label: 'Timeline', slug: 'timeline' },
  { path: '/faq',               label: 'FAQ',      slug: 'faq' },
  { path: '/people',            label: 'People',   slug: 'people' },
  { path: '/notes',             label: 'Notes',    slug: 'notes' },
];

export default function Layout({ children }) {
  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-header-inner">
          <NavLink to="/" className="layout-logo" aria-label="Eagle Guide — Home">
            <img
              src="./assets/eagle/mark.png"
              alt=""
              width="40"
              height="40"
              loading="eager"
              className="layout-logo-eagle"
            />
            <span className="layout-logo-text">Eagle Guide</span>
          </NavLink>
          <span className="layout-subtitle">Canyon Ridge MS · 2026–27</span>
        </div>
      </header>

      <div className="layout-body">
        <nav className="layout-sidebar" aria-label="Main navigation">
          <ul className="layout-nav-list">
            {NAV_ITEMS.map(({ path, label, slug }) => (
              <li key={path}>
                <NavLink
                  to={path}
                  end={path === '/'}
                  className={({ isActive }) =>
                    `layout-nav-link${isActive ? ' layout-nav-link--active' : ''}`
                  }
                >
                  <span className="layout-nav-icon" aria-hidden="true">
                    <img src={`/assets/eagle/page-icons/${slug}.png`} width="28" height="28" alt="" />
                  </span>
                  <span className="layout-nav-label">{label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <main id="main-content" className="layout-main">
          {children}
        </main>
      </div>

      <nav className="layout-bottom-nav" aria-label="Main navigation">
        <ul className="layout-bottom-nav-list">
          {NAV_ITEMS.map(({ path, label, slug }) => (
            <li key={path}>
              <NavLink
                to={path}
                end={path === '/'}
                className={({ isActive }) =>
                  `layout-bottom-nav-link${isActive ? ' layout-bottom-nav-link--active' : ''}`
                }
              >
                <span className="layout-bottom-nav-icon" aria-hidden="true">
                  <img src={`/assets/eagle/page-icons/${slug}.png`} width="28" height="28" alt="" />
                </span>
                <span className="layout-bottom-nav-label">{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
